import React from 'react';

interface Props {
	size: number;
}

export const CuriousIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		className='margin--8'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>curious</title>
		<path d='M7.27 12.41a1.63 1.63 0 111.63-1.63 1.63 1.63 0 01-1.63 1.63zm0-2.43a.81.81 0 10.81.8.81.81 0 00-.81-.78zM11.86 18.09a1.83 1.83 0 01-1.62-1.63c0-.82.9-.82 1.62-.82s1.63 0 1.63.82a1.83 1.83 0 01-1.63 1.63zm-.79-1.58c0 .23.4.76.79.76s.75-.53.81-.76a3.85 3.85 0 00-.81-.05 3.65 3.65 0 00-.79.05zM16.46 13.36a2.85 2.85 0 112.84-2.85 2.85 2.85 0 01-2.84 2.85zm0-4.87a2 2 0 102 2 2 2 0 00-2-2z' />
		<path d='M12 23.36A11.36 11.36 0 1123.36 12 11.38 11.38 0 0112 23.36zm0-21.9A10.54 10.54 0 1022.54 12 10.55 10.55 0 0012 1.46z' />
		<path d='M20.3 19.28a.41.41 0 01-.39-.42c.21-6.22.1-7.3 0-7.48s-.35-.37-.92-.2a.42.42 0 01-.51-.28.41.41 0 01.28-.51 1.53 1.53 0 011.85.58c.14.2.33.48.08 7.92a.41.41 0 01-.39.39zM15.51 11.05a.4.4 0 01-.29-.12.41.41 0 010-.58l1.08-1.08a.41.41 0 11.58.58l-1.08 1.08a.42.42 0 01-.29.12zM16.66 11.66a.4.4 0 01-.29-.12.41.41 0 010-.58l.81-.81a.41.41 0 01.58.58l-.81.81a.42.42 0 01-.29.12z' />
	</svg>
);
